import { render, staticRenderFns } from "./Vacinas.vue?vue&type=template&id=70bc6cb4"
import script from "./Vacinas.vue?vue&type=script&lang=js"
export * from "./Vacinas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports